<template>
    <div>
        <load-screen-component :is-loading="isLoading"></load-screen-component>
        <page-header :page-title="!widthMd(454) ? this.t('APP.TITLE.SYSTEM') :'Disponibilidade'"
                     @selectAllotment="alterAllotment"
                     with-none-allotment
                     :allotment-index="this.$hasPermission('Dashboard_resume') ? allotmentId : false"
        ></page-header>
        <div class="main-container">
            <cardsGeralRedirectionsComponent :peoples="peoples" :reservesActive="reservesActive" :allotments="allotments"
                                             :lots="lots" :clicksign_documents="clicksign_documents" :drive="drive"
                                             :reservesExpiring="reservesExpiring">
            </cardsGeralRedirectionsComponent>
            <div class="row gutters">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" v-show="chartGraphic">
                    <div class="card home-chart-card">
                        <div class="home-chart-card__header">
                            <h5 class="home-section-title">
                                <i class="icon-schedule"></i>{{ this.t('GRAPHICS.PROGRESS_RESERVE') }}</h5>
                            <div class="home-segmented" v-if="loadingReserve">
                                <button type="button" :class="grapicDay ?'' :'active'"
                                        @click="setLastDaysReserveProgessGraphic(false)"><i v-if="!grapicDay"
                                                                                           class="icon-check-circle"></i>
                                    Últimos 12 Meses
                                </button>
                                <button type="button" @click="setLastDaysReserveProgessGraphic(true)"
                                        :class="grapicDay ?'active' :''"><i v-if="grapicDay" class="icon-check-circle"></i>
                                    Últimos 30 Dias
                                </button>
                            </div>
                        </div>
                        <div class="main-container" style="min-height: 300px">
                            <div id="chartReserve" :style="blurLoadingR('reserve')"></div>
                        </div>
                        <div v-if="!loadingReserve" :class="{ loader: false, fadeout: !loadingReserve}"
                             class="home-chart-loading">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12" v-if="this.$hasPermission('Dashboard_resume')">
                    <h5 class="home-section-title home-section-title--block">
                        <i class="icon-users"></i>Resumo de pessoas</h5>
                </div>
                <div class="home-charts-grid col-12" v-if="this.$hasPermission('Dashboard_resume')">
                    <div class="card home-chart-card" :style="loadingGrafic('resumM')">
                        <div class="spinner-border align-self-center" role="status" v-if="loadingChartMaritalStatus">
                            <span class="sr-only"></span>
                        </div>
                        <div id="clientMaritalStatus"></div>
                    </div>
                    <div class="card home-chart-card" :style="loadingGrafic('resumM')">
                        <div class="spinner-border align-self-center" role="status" v-if="loadingChartAge">
                            <span class="sr-only"></span>
                        </div>
                        <div id="clientAge"></div>
                    </div>
                    <div class="card home-chart-card" :style="loadingGrafic('resumM')">
                        <div class="spinner-border align-self-center" role="status" v-if="loadingChartSex">
                            <span class="sr-only"></span>
                        </div>
                        <div id="clientSex"></div>
                    </div>
                    <div class="card home-chart-card" :style="loadingGrafic('resumM')">
                        <div class="spinner-border align-self-center" role="status" v-if="loadingChartType">
                            <span class="sr-only"></span>
                        </div>
                        <div id="clientType"></div>
                    </div>
                </div>
                <cardsResumReserves :allotmentId="allotmentId" :resumReserve="resumReserve"></cardsResumReserves>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" v-show="showGraficBroker">
                    <transition name="flap">
                        <div class="card home-chart-card" :class="{ 'flap-animation': isFlapping }">
                            <div class="home-chart-card__header">
                                <h5 class="home-section-title">
                                    <i class="icon-user"></i>{{ this.t('GRAPHICS.RESERVES_CONFIRMED_BROKER_VS') }}</h5>
                                <div class="home-chart-card__filters">
                                    <div class="home-chart-card__field" v-if="!widthMd(612)">
                                        <label> Período Inicial:</label>
                                        <input type="date" class="form-control" v-model="dateStart"
                                               id="dateStart"
                                               @change="changeDs">
                                    </div>
                                    <div class="home-chart-card__field" v-if="!widthMd(612)">
                                        <label> Período Final:</label>
                                        <input type="date" v-model="dateEnd" class="form-control"
                                               id="dateEnd"
                                               @change="changeDE">
                                    </div>
                                    <div class="home-chart-card__field">
                                        <label> Gráfico:</label>
                                        <Select2 :settings="{width:'100%'}" placeholder="Filtrar"
                                                 :options="[
                                                      {id: '1', text: 'QTD. Reservas Confirmadas'},
                                                      {id: '2', text: 'Preço Total - Reservas Confirmadas'}
                                              ]"
                                                 v-model="typeGrapficBroker"
                                                 @select="alterTypeGraphicBroker"
                                                 id="graphicForm">
                                        </Select2>
                                    </div>
                                </div>
                            </div>
                            <div class="main-container" style="min-height: 350px; padding-bottom: 0">
                                <div id="chartReserveBroker" :style="blurLoadingR('broker')"></div>
                            </div>
                            <div v-if="!loadingReserveBroker" :class="{ loader: false, fadeout: !loadingReserveBroker}"
                                 class="home-chart-loading">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" v-show="showGraficImobi">
                    <transition name="flap">
                        <div class="card home-chart-card" :class="{ 'flap-animation': isFlappingImobi }">
                            <div class="home-chart-card__header">
                                <h5 class="home-section-title">
                                    <i class="icon-layers"></i>{{ this.t('GRAPHICS.RESERVES_CONFIRMED_IMOBI_VS') }}
                                </h5>
                                <div class="home-chart-card__filters">
                                    <div class="home-chart-card__field" v-if="!widthMd(612)">
                                        <label> Período Inicial:</label>
                                        <input type="date" class="form-control" v-model="dateStartImobi"
                                               id="dateStartImobi"
                                               @change="changeDsImobi">
                                    </div>
                                    <div class="home-chart-card__field" v-if="!widthMd(612)">
                                        <label> Período Final:</label>
                                        <input type="date" v-model="dateEndImobi" class="form-control"
                                               id="dateEndImobi"
                                               @change="changeDEImobi">
                                    </div>
                                    <div class="home-chart-card__field">
                                        <label> Gráfico:</label>
                                        <Select2 :settings="{width:'100%'}" placeholder="Filtrar"
                                                 :options="[
                                                      {id: '1', text: 'QTD. Reservas Confirmadas'},
                                                      {id: '2', text: 'Preço Total - Reservas Confirmadas'}
                                              ]"
                                                 v-model="typeGrapficImobi"
                                                 @select="alterTypeGraphicImobi"
                                                 id="graphicFormImobi">
                                        </Select2>
                                    </div>
                                </div>
                            </div>
                            <div class="main-container" style="min-height: 400px; padding-bottom: 0">
                                <div id="chartReserveImobi" :style="blurLoadingR('imobi')"></div>
                            </div>
                            <div v-if="!loadingReserveImobi" :class="{ loader: false, fadeout: !loadingReserveImobi}"
                                 class="home-chart-loading">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Dashboard from "@/services/Dashboard";
import ApexCharts from 'apexcharts';
import {useToast} from "vue-toastification";
import {useI18n} from "vue-i18n";
import {mapState} from "vuex";
import loadScreenComponent from '../../components/layouts/loadScreenComponent';
import PageHeader from "@/components/layouts/pageHeader";
import permission from "../../components/permission";
import Select2 from 'vue3-select2-component';
import moment from 'moment';
import Clients from '../../services/Clients';
import cardsGeralRedirectionsComponent from './partials/cardsGeralRedirectionsComponent';
import cardsResumReserves from './partials/cardsResumReserves';

function exportCustomCSV(chart) {
    const categories = chart.w.globals.categoryLabels;
    const series = chart.w.config.series;
    let csv = ["Categoria", ...series.map(s => s.name)].join(";") + "\n";
    categories.forEach((categoria, i) => {
        let row = [categoria];
        series.forEach(s => {
            let value = s.data[i];
            if (typeof value === "number") {
                value = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
            }
            row.push(value);
        });
        csv += row.join(";") + "\n";
    });
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "grafico.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export default {
    name: 'Home',
    mixins: [permission],
    components: {
        loadScreenComponent,
        PageHeader,
        Select2,
        cardsGeralRedirectionsComponent,
        cardsResumReserves,
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    computed: {
        ...mapState({
            isLoading: 'isLoading',
            hasTwoAllotments: 'hastwoAllotments',
            allotmentLoad: 'allotmentLoad',
            allotmentsStore: 'allotments',
            hasConfigClickSign: 'hasConfigClickSign',
            hasAllotments: 'hasAllotments',
        }),
        blurLoading() {
            if (!this.loadingMovements) {
                return '-webkit-filter: blur(5px)';
            }
            return '';
        },
    },
    unmounted() {
        this.chartGraphic?.destroy();
        this.chartGraphicBroker?.destroy();
        this.chartGraphicImobi?.destroy();
        this.chartSex?.destroy();
        this.chartType?.destroy();
        this.chartAge?.destroy();
        this.chartMaritalStatus?.destroy();
    },
    beforeRouteLeave(to, from, next) {
        this.chartGraphic?.destroy();
        this.chartGraphicBroker?.destroy();
        this.chartGraphicImobi?.destroy();
        this.chartSex?.destroy();
        this.chartType?.destroy();
        this.chartAge?.destroy();
        this.chartMaritalStatus?.destroy();
        return next();
    },
    data() {
        return {
            chartSex: null,
            chartAge: null,
            chartType: null,
            chartMaritalStatus: null,
            loadingChartSex: null,
            loadingChartType: null,
            loadingChartAge: null,
            loadingChartMaritalStatus: null,
            clicksign_documents: {},
            isFlapping: false,
            isFlappingImobi: false,
            typeGrapficBroker: '1',
            typeGrapficImobi: '1',
            grapicDay: false,
            dateStart: null,
            dateStartImobi: null,
            dateEnd: null,
            dateEndImobi: null,
            showGraficImobi: false,
            showGraficBroker: false,
            resumReserve: {reservesByStatus: []},
            chartGraphic: null,
            chartGraphicBroker: null,
            chartGraphicImobi: null,
            peoples: {},
            drive: {
                total: null,
                maxStore: null
            },
            lots: {},
            chartOptions: {},
            chartOptionsReserve: {},
            series: [],
            allotmentId: 'selecione',
            chart: null,
            chartReserve: null,
            loadingMovements: true,
            loadingReserve: true,
            loadingReserveImobi: true,
            loadingReserveBroker: true,
            allotments: {},
            reservesActive: {},
            reservesExpiring: {},
        }
    },
    async mounted() {
        sessionStorage.setItem('allotmentId', 'selecione');
        if (this.$hasPermission('Dashboard_resume')) {
                this.getTotalDriveStored();
                this.loadCharts();
        }
    },
    methods: {
        graficResumClientAge() {
            this.loadingChartAge = true;
            this.chartAge?.destroy();
            Clients.getResumClientAge(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                resp.data.forEach(i => {
                    series.push(i.total);
                    labels.push(`${i.age_range} (${i.generation})`);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '300px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Resumo por idade',
                        align: 'center',
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                                total: {
                                    enabled: true,
                                }
                            }
                        }
                    },
                    colors: ['#00e396'],
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartAge = new ApexCharts(document.querySelector("#clientAge"), options);
                this.chartAge.render();
                this.loadingChartAge = false;
            })
        },
        graficResumClientMaritalStatus() {
            this.loadingChartMaritalStatus = true;
            this.chartMaritalStatus?.destroy();
            Clients.getResumClientMaritalStatus(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                Object.values(resp.data)?.forEach(i => {
                    series.push(i.total);
                    labels.push(i.marital_status);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '300px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Resumo por estado civil',
                        align: 'center',
                    },
                    colors: ['#00e396'],
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                                total: {
                                    enabled: true,
                                }
                            }
                        }
                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                if (document.querySelector("#clientMaritalStatus")){
                    this.chartMaritalStatus = new ApexCharts(document.querySelector("#clientMaritalStatus"), options);
                    this.chartMaritalStatus?.render();
                }
                this.loadingChartMaritalStatus = false;
            })
        },
        graficResumClientSex() {
            this.loadingChartSex = true;
            this.chartSex?.destroy();
            Clients.getResumClientSex(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                resp.data.forEach(i => {
                    series.push(i.total);
                    labels.push(i.sex);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '300px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    colors: ['#00e396'],
                    title: {
                        text: 'Resumo por gênero',
                        align: 'center',
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartSex = new ApexCharts(document.querySelector("#clientSex"), options);
                this.chartSex.render();
                this.loadingChartSex = false;
            })
        },
        graficResumClientType() {
            this.loadingChartType = true;
            this.chartClientType?.destroy();
            Clients.getResumClientType(this.allotmentId).then(resp => {
                let series = [resp.data.fisical, resp.data.juridical];
                let labels = ['Física', 'Jurídica'];
                if (resp.data?.not_informed) {
                    labels.push('Não Informado');
                    series.push(resp.data.not_informed);
                }
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '300px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    colors: ['#00e396'],
                    title: {
                        text: 'Resumo por Tipo',
                        align: 'center',
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartClientType = new ApexCharts(document.querySelector("#clientType"), options);
                this.chartClientType.render();
                this.loadingChartType = false;
            })
        },
        loadingGrafic(context) {
            if (context === 'resumS' && this.loadingChartSex) return 'display: flex; justify-content: center;';
            if (context === 'resumA' && this.loadingChartAge) return 'display: flex; justify-content: center;';
            if (context === 'resumM' && this.loadingChartMaritalStatus) return 'display: flex; justify-content: center;';
            if (context === 'resumT' && this.loadingChartType) return 'display: flex; justify-content: center;';
            return '';
        },
        changeDsImobi() {
            if (!this.dateStartImobi) {
                document.getElementById('dateStartImobi')?.classList?.remove('is-invalid');
                this.dateStartImobi = null;
                this.alterTypeGraphicImobi();
                return;
            }
            if (moment().isValid(this.dateStartImobi)) {
                if (moment(this.dateStartImobi).isAfter('1950-01-01') && (moment(this.dateStartImobi).isSame(moment(), 'day') || moment(this.dateStartImobi).isBefore(moment()))) {
                    document.getElementById('dateStartImobi')?.classList?.remove('is-invalid');
                    this.alterTypeGraphicImobi();
                } else {
                    document.getElementById('dateStartImobi')?.classList?.add('is-invalid');
                }
            } else {
                document.getElementById('dateStartImobi')?.classList?.add('is-invalid');
            }
        },
        changeDs() {
            if (!this.dateStart) {
                document.getElementById('dateStart')?.classList?.remove('is-invalid');
                this.dateStart = null;
                this.alterTypeGraphicBroker();
                return;
            }
            if (moment().isValid(this.dateStart)) {
                if (moment(this.dateStart).isAfter('1950-01-01') && (moment(this.dateStart).isSame(moment(), 'day') || moment(this.dateStart).isBefore(moment()))) {
                    document.getElementById('dateStart')?.classList?.remove('is-invalid');
                    this.alterTypeGraphicBroker();
                } else {
                    document.getElementById('dateStart')?.classList?.add('is-invalid');
                }
            } else {
                document.getElementById('dateStart')?.classList?.add('is-invalid');
            }
        },
        changeDEImobi() {
            if (!this.dateEndImobi) {
                document.getElementById('dateEndImobi')?.classList?.remove('is-invalid');
                this.dateEndImobi = null;
                this.alterTypeGraphicImobi();
                return;
            }
            if (moment().isValid(this.dateEndImobi)) {
                if (moment(this.dateEndImobi).isAfter('1950-01-01') && (moment(this.dateEndImobi).isSame(moment(), 'day') || moment(this.dateEndImobi).isBefore(moment()))) {
                    document.getElementById('dateEndImobi')?.classList?.remove('is-invalid');
                    this.alterTypeGraphicImobi();
                } else {
                    document.getElementById('dateEndImobi')?.classList?.add('is-invalid');
                }
            } else {
                document.getElementById('dateEndImobi')?.classList?.add('is-invalid');
            }
        },
        changeDE() {
            if (!this.dateEnd) {
                document.getElementById('dateEnd')?.classList?.remove('is-invalid');
                this.dateEnd = null;
                this.alterTypeGraphicBroker();
                return;
            }
            if (moment().isValid(this.dateEnd)) {
                if (moment(this.dateEnd).isAfter('1950-01-01') && (moment(this.dateEnd).isSame(moment(), 'day') || moment(this.dateEnd).isBefore(moment()))) {
                    document.getElementById('dateEnd')?.classList?.remove('is-invalid');
                    this.alterTypeGraphicBroker();
                } else {
                    document.getElementById('dateEnd')?.classList?.add('is-invalid');
                }
            } else {
                document.getElementById('dateEnd')?.classList?.add('is-invalid');
            }
        },
        widthMd(size = 1025, smaller = '<') {
            if (smaller == '<') {
                return window.innerWidth < size;
            } else {
                return window.innerWidth > size;
            }
        },
        alterTypeGraphicImobi() {
            this.isFlappingImobi = true;
            setTimeout(() => {
                this.isFlappingImobi = false;
            }, 600);
            this.renderChartReserveConfirmImobi(this.typeGrapficImobi);
        },
        alterTypeGraphicBroker() {
            this.isFlapping = true;
            setTimeout(() => {
                this.isFlapping = false;
            }, 600);
            this.renderChartReserveConfirmBroker(this.typeGrapficBroker);
        },
        blurLoadingR(context) {
            if (context === 'imobi') {
                if (!this.loadingReserveImobi) {
                    return '-webkit-filter: blur(5px)';
                }
            }
            if (context === 'broker') {
                if (!this.loadingReserveBroker) {
                    return '-webkit-filter: blur(5px)';
                }
            }
            if (context === 'reserve') {
                if (!this.loadingReserve) {
                    return '-webkit-filter: blur(5px)';
                }
            }
            return '';
        },
        alterAllotment(id) {
            this.allotmentId = id;
            sessionStorage.setItem('allotmentId', this.allotmentId);
            this.loadCharts();
        },
        setLastDaysReserveProgessGraphic(bool) {
            this.grapicDay = bool;
            this.renderChartReserve();
        },
        loadCharts() {
            if (this.$hasPermission('Dashboard_resume') && this.allotmentId) {
                this.getResume(localStorage.getItem('companyId'));
                this.renderChartReserve();
                this.getResumReserveByAllotment();
                this.renderChartReserveConfirmBroker();
                this.renderChartReserveConfirmImobi();
                this.graficResumClientSex();
                this.graficResumClientType();
                this.graficResumClientAge();
                this.graficResumClientMaritalStatus();
            }
        },
        getResumReserveByAllotment() {
            Dashboard.summaryReservesByAllotment(this.allotmentId).then(resp => {
                this.resumReserve = resp.data;
            }).catch(() => {
                this.resumReserve = {reservesByStatus: []}
            })
        },
        async getTotalDriveStored() {
            Dashboard.totalStoredByCompany().then(resp => {
                this.drive = resp.data
            });
        },
        async getResume(companyId) {
            await Dashboard.companyResume(companyId, this.allotmentId).then((resp) => {
                this.peoples = resp.data?.people;
                this.lots = resp.data?.lots;
                this.allotments = resp.data?.allotments;
                this.reservesActive = resp.data?.reserves_active;
                this.reservesExpiring = resp.data?.reserves_next_expire;
                this.clicksign_documents = resp.data?.clicksign_documents;
            }).catch((err) => {
                this.errorMsg(err);
            })
        },
        async renderChartReserveConfirmImobi(type = '1') {
            this.loadingReserveImobi = false;
            if (this.dateStartImobi && this.dateEndImobi && moment().isValid(this.dateStartImobi) && moment().isValid(this.dateEndImobi)) {
                if (moment(this.dateEndImobi).isBefore(moment(this.dateStartImobi))) {
                    let aux = this.dateStartImobi;
                    this.dateStartImobi = this.dateEndImobi;
                    this.dateEndImobi = aux;
                }
            }
            await Dashboard.getReservesImobiByAllotment(this.allotmentId, type, this.dateStartImobi, this.dateEndImobi).then(async resp => {
                let data = resp?.data;
                if (!this.dateStartImobi && !this.dateEndImobi && (!data || !data[0]?.length)){
                    this.loadingReserveBroker = true;
                    return;
                }
                for (const dataKey in data[0]) {
                    if (!data[0][dataKey]){
                        data[0][dataKey] = "";
                    }
                }
                const chartOptionsReserve = {
                    series: data[1],
                    colors: type === '2' ? ['#3FBF3F', '#e26067'] : ['#2bc3b6', '#3FBF3F', '#e26067'],
                    chart: {
                        type: 'bar',
                        height: '100%',
                        width: '100%',
                        toolbar: {
                            show: true,
                            offsetX: 0,
                            offsetY: 0,
                            tools: {
                                download: false,
                                selection: true,
                                zoom: true,
                                zoomin: true,
                                zoomout: true,
                                pan: true,
                                reset: true,
                                customIcons: [
                                    {
                                        icon: '<div class="apexcharts-menu-icon" title="Menu"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path></svg></div>',
                                        index: 0,
                                        title: 'Download Personalizado',
                                        class: 'custom-download',
                                        click: chart => {
                                            let menuDrop = chart.el.querySelector('.apexcharts-menu');
                                            if (!chart.el.querySelector('.apexcharts-menu-open')) {
                                                setTimeout(() => {
                                                    menuDrop.innerHTML =
                                                            `
                                                                <div id="exportSVGImobi" class="apexcharts-menu-item" title="Download SVG">Download SVG</div>
                                                                <div id="exportPNGImobi" class="apexcharts-menu-item exportPNG"  title="Download PNG">Download PNG</div>
                                                                <div id="exportXLSXImobi" class="apexcharts-menu-item exportCSV"  title="Download CSV">Download XLSX</div>
                                                    `;
                                                    menuDrop.classList.add('apexcharts-menu-open');
                                                    menuDrop.classList.add('text-left');
                                                    menuDrop.querySelector('#exportSVGImobi').addEventListener('click', () => {
                                                        try {
                                                            const paper = chart.paper();
                                                            const svgContent = paper.svg();
                                                            const svgBlob = new Blob([svgContent], {type: 'image/svg+xml;charset=utf-8'});
                                                            const svgURL = URL.createObjectURL(svgBlob);
                                                            const link = document.createElement('a');
                                                            link.href = svgURL;
                                                            link.download = 'chart.svg';
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                            URL.revokeObjectURL(svgURL);
                                                        } catch (error) {
                                                            console.error('Erro ao gerar o SVG:', error);
                                                        }
                                                    });
                                                    menuDrop.querySelector('#exportPNGImobi').addEventListener('click', () => {
                                                        chart.dataURI().then(({imgURI}) => {
                                                            const link = document.createElement('a');
                                                            link.href = imgURI;
                                                            link.download = 'chart.png';
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                        });
                                                    });
                                                    menuDrop.querySelector('#exportXLSXImobi').addEventListener('click', () => {
                                                        Dashboard.exportResumImobiByAllotment(sessionStorage.getItem('allotmentId'),type, this.dateStartImobi, this.dateEndImobi);
                                                    });
                                                }, 100)

                                            } else {
                                                setTimeout(() => {
                                                    menuDrop?.classList?.remove('apexcharts-menu-open')
                                                }, 1000)
                                            }
                                        }
                                    },
                                    {
                                        icon: '<i class="fas fa-file-csv"></i>',
                                        index: 0,
                                        title: 'Exportar CSV customizado',
                                        class: 'export-csv',
                                        click: (chart) => {
                                            exportCustomCSV(chart);
                                        }
                                    }
                                ]
                            },
                            autoSelected: 'zoom'
                        },
                    },
                    responsive: [
                        {
                            breakpoint: 1000,
                            options: {
                                legend: {
                                    position: "bottom"
                                }
                            }
                        }
                    ],
                    legend: {
                        position: 'top',
                        horizontalAlign: 'center',
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '55%',
                            endingShape: 'rounded',
                            borderRadius: 3,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                        position: 'bottom',
                        textAnchor: 'middle',
                        distributed: false,
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            colors: ['#000']
                        },
                        formatter: (val) => {
                            if (type === '2') {
                                return Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(val);
                            }
                            return val;
                        }
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        categories: data[0],
                        position: 'bottom',
                        tickPlacement: 'on',
                        labels: {
                            rotate: -55,
                            rotateAlways: true,
                            style: {
                                fontSize: '10px',
                            },
                            minHeight: 150,
                            trim: true,
                        },
                    },
                    yaxis: {
                        title: {
                            text: 'reservas'
                        },
                        labels: {
                            formatter: (val) => {
                                if (type === '2') {
                                    return Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(val);
                                }
                                return val;
                            }
                        }
                    },
                    fill: {
                        opacity: 1,
                    },
                };
                this.plotChart(chartOptionsReserve, 'chartReserveImobi');
            }).catch((err) => {
                this.errorMsg(err);
                this.loadingReserveImobi = true
            });
        },
        async renderChartReserve(companyId) {
            this.loadingReserve = false;
            if (!companyId) {
                companyId = localStorage.getItem('companyId');
            }
            Dashboard.datasAnualReserve(companyId, this.allotmentId, this.grapicDay).then(resp => {
                let result = resp.data
                let seriesReserve = [];

                seriesReserve.push({
                    name: result.name1,
                    data: result.reserves
                });

                seriesReserve.push({
                    name: result.name2,
                    data: result.reservesConfirmed
                });

                seriesReserve.push({
                    name: result.name3,
                    data: result.reservesExpiredAndInterrupted
                });

                seriesReserve.push({
                    name: result.name4,
                    data: result.reservesInProgress
                });
                seriesReserve.push({
                    name: result.name5,
                    data: result.reservesSaleCanceled
                });

                seriesReserve.push({
                    name: result.name6,
                    data: result.lots_sold
                });

                let chartOptionsReserve = {
                    chart: {
                        height: '90%',
                        type: 'area',
                        width: '100%',
                        defaultLocale: 'pt',
                        locales: [{
                            name: 'pt',
                            options: {
                                toolbar: {
                                    download: 'Download SVG',
                                    selection: 'Selecionar',
                                    selectionZoom: 'Selecionar Zoom',
                                    zoomIn: 'Aumentar Zoom',
                                    zoomOut: 'Reduzir Zoom',
                                    pan: 'Panorama',
                                    reset: 'Resetar Zoom',
                                }
                            }
                        }]
                    },
                    responsive: [
                        {
                            breakpoint: 1450,
                            options: {
                                legend: {
                                    position: "bottom"
                                }
                            }
                        }
                    ],
                    legend: {
                        position: 'top',
                        horizontalAlign: 'center',
                    },
                    noData: {
                        text: 'Nenhum dado para ser carregado',
                        align: 'center',
                        verticalAlign: 'middle',
                    },
                    series: seriesReserve,
                    xaxis: {
                        convertedCatToNumeric: false,
                        categories: result.categories
                    },
                colors: ['#2bc3b6', '#3FBF3F', "#76a5b3",  "#008FFB","#A5978B", '#e26067'],
               // colors: ["#008FFB", '#3FBF3F', '#2bc3b6',  "#775DD0","#A5978B", '#e26067'],
                }
                this.plotChart(chartOptionsReserve, 'chartReserve');
            }).catch((err) => {
                this.errorMsg(err);
                this.loadingReserve = true
            });
        },
        async renderChartReserveConfirmBroker(type = '1') {
            this.loadingReserveBroker = false;
            if (this.dateStart && this.dateEnd && moment().isValid(this.dateStart) && moment().isValid(this.dateEnd)) {
                if (moment(this.dateEnd).isBefore(moment(this.dateStart))) {
                    let aux = this.dateStart;
                    this.dateStart = this.dateEnd;
                    this.dateEnd = aux;
                }
            }
            await Dashboard.getReservesBrokersByAllotment(this.allotmentId, type, this.dateStart, this.dateEnd).then(async resp => {
                let data = resp?.data;
                if (!this.dateStart && !this.dateEnd && (!data || !data[0]?.length)){
                    this.loadingReserveBroker = true;
                    return;
                }
                for (const dataKey in data[0]) {
                    if (!data[0][dataKey]){
                        data[0][dataKey] = "";
                    }
                }
                const vm = this;
                let chartOptionsReserve = {
                    series: data[1],
                    colors: type === '2' ? ['#3FBF3F', '#e26067'] : ['#2bc3b6', '#3FBF3F', '#e26067'],
                    chart: {
                        type: 'bar',
                        height: '100%',
                        width: '100%',
                        toolbar: {
                            show: true,
                            tools: {
                                download: false,
                                selection: true,
                                zoom: true,
                                zoomin: true,
                                zoomout: true,
                                pan: true,
                                reset: true,
                                customIcons: type === '2' ?  [
                                    {
                                        icon: '<div class="apexcharts-menu-icon" title="Menu"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path></svg></div>',
                                        index: 0,
                                        title: 'Download Personalizado',
                                        class: 'custom-download',
                                        click: chart => {
                                            let menuDrop = chart.el.querySelector('.apexcharts-menu');
                                            if (!chart.el.querySelector('.apexcharts-menu-open')) {
                                                setTimeout(() => {
                                                    menuDrop.innerHTML =
                                                            `
                                                                <div id="exportSVGBroker" class="apexcharts-menu-item" title="Download SVG">Download SVG</div>
                                                                <div id="exportPNGBroker" class="apexcharts-menu-item exportPNG"  title="Download PNG">Download PNG</div>
                                                                <div id="exportCSVBroker" class="apexcharts-menu-item exportCSV"  title="Download CSV">Download CSV</div>
                                                                <div id="exportXLSXBroker" class="apexcharts-menu-item exportCSV"  title="Download CSV">Download XLSX</div>
                                                    `;
                                                    menuDrop.classList.add('apexcharts-menu-open');
                                                    menuDrop.classList.add('text-left');
                                                    menuDrop.querySelector('#exportSVGBroker').addEventListener('click', () => {
                                                        try {
                                                            const paper = chart.paper();
                                                            const svgContent = paper.svg();
                                                            const svgBlob = new Blob([svgContent], {type: 'image/svg+xml;charset=utf-8'});
                                                            const svgURL = URL.createObjectURL(svgBlob);
                                                            const link = document.createElement('a');
                                                            link.href = svgURL;
                                                            link.download = 'chart.svg';
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                            URL.revokeObjectURL(svgURL);
                                                        } catch (error) {
                                                            console.error('Erro ao gerar o SVG:', error);
                                                        }
                                                    });
                                                    menuDrop.querySelector('#exportPNGBroker').addEventListener('click', () => {
                                                        chart.dataURI().then(({imgURI}) => {
                                                            const link = document.createElement('a');
                                                            link.href = imgURI;
                                                            link.download = 'chart.png';
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                        });
                                                    });
                                                    menuDrop.querySelector('#exportCSVBroker').addEventListener('click', () => {
                                                        chart.exportToCSV()?.then(({csv}) => {
                                                            const blob = new Blob([csv], {type: 'text/csv'});
                                                            const url = URL.createObjectURL(blob);
                                                            const a = document.createElement('a');
                                                            a.href = url;
                                                            a.download = 'chart.csv';
                                                            document.body.appendChild(a);
                                                            a.click();
                                                            document.body.removeChild(a);
                                                        });
                                                    });
                                                    menuDrop.querySelector('#exportXLSXBroker').addEventListener('click', () => {
                                                        Dashboard.exportResumBrokerByAllotment(sessionStorage.getItem('allotmentId'));
                                                    });
                                                }, 100)

                                            } else {
                                                setTimeout(() => {
                                                    menuDrop?.classList?.remove('apexcharts-menu-open')
                                                }, 1000)
                                            }
                                        }
                                    },
                                    {
                                        icon: '<i class="fas fa-file-csv"></i>',
                                        index: 0,
                                        title: 'Exportar CSV customizado',
                                        class: 'export-csv',
                                        click: (chart) => {
                                            exportCustomCSV(chart);
                                        }
                                    }
                                ] : [
                                    {
                                        icon: '<div class="apexcharts-menu-icon" title="Menu"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path></svg></div>',
                                        index: 0,
                                        title: 'Download Personalizado',
                                        class: 'custom-download',
                                        click: function (chart) {
                                            let menuDrop = chart.el.querySelector('.apexcharts-menu');
                                            if (!chart.el.querySelector('.apexcharts-menu-open')) {
                                                setTimeout(() => {
                                                    menuDrop.innerHTML =
                                                            `
                                                                <div id="exportSVGBroker" class="apexcharts-menu-item" title="Download SVG">Download SVG</div>
                                                                <div id="exportPNGBroker" class="apexcharts-menu-item exportPNG"  title="Download PNG">Download PNG</div>
                                                                <div id="exportCSVBroker" class="apexcharts-menu-item exportCSV"  title="Download CSV">Download CSV</div>
                                                                <div id="exportXLSXBroker" class="apexcharts-menu-item exportCSV"  title="Download CSV">Download XLSX</div>
                                                    `;
                                                    menuDrop.classList.add('apexcharts-menu-open');
                                                    menuDrop.classList.add('text-left');
                                                    menuDrop.querySelector('#exportSVGBroker').addEventListener('click', () => {
                                                        try {
                                                            const paper = chart.paper();
                                                            const svgContent = paper.svg();
                                                            const svgBlob = new Blob([svgContent], {type: 'image/svg+xml;charset=utf-8'});
                                                            const svgURL = URL.createObjectURL(svgBlob);
                                                            const link = document.createElement('a');
                                                            link.href = svgURL;
                                                            link.download = 'chart.svg';
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                            URL.revokeObjectURL(svgURL);
                                                        } catch (error) {
                                                            console.error('Erro ao gerar o SVG:', error);
                                                        }
                                                    });
                                                    menuDrop.querySelector('#exportPNGBroker').addEventListener('click', () => {
                                                        chart.dataURI().then(({imgURI}) => {
                                                            const link = document.createElement('a');
                                                            link.href = imgURI;
                                                            link.download = 'chart.png';
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                        });
                                                    });
                                                    menuDrop.querySelector('#exportCSVBroker').addEventListener('click', () => {
                                                        chart.exportToCSV()?.then(({csv}) => {
                                                            const blob = new Blob([csv], {type: 'text/csv'});
                                                            const url = URL.createObjectURL(blob);
                                                            const a = document.createElement('a');
                                                            a.href = url;
                                                            a.download = 'chart.csv';
                                                            document.body.appendChild(a);
                                                            a.click();
                                                            document.body.removeChild(a);
                                                        });
                                                    });
                                                    menuDrop.querySelector('#exportXLSXBroker')
                                                        .addEventListener('click', () => vm.getDataChart(type), { once: true });
                                                }, 100)

                                            } else {
                                                setTimeout(() => {
                                                    menuDrop?.classList?.remove('apexcharts-menu-open')
                                                }, 1000)
                                            }
                                        }
                                    }
                                ]
                            },
                        },
                        zoom: {
                            enabled: true
                        }
                    },
                    responsive: [
                        {
                            breakpoint: 1000,
                            options: {
                                legend: {
                                    position: "bottom"
                                }
                            }
                        }
                    ],
                    legend: {
                        position: 'top',
                        horizontalAlign: 'center',
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '55%',
                            endingShape: 'rounded',
                            borderRadius: 3,
                            dataLabels: {
                                position: 'top'
                            }
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        textAnchor: 'middle',
                        distributed: false,
                        offsetX: 0,
                        offsetY: -24,
                        formatter: (val) => {
                            if (type === '2') {
                                return Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(val);
                            }
                            return val;
                        },
                        style: {
                            fontSize: '14px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 'bold',
                            colors: undefined
                        },
                        background: {
                            enabled: true,
                            foreColor: '#fff',
                            padding: 4,
                            borderRadius: 2,
                            borderWidth: 1,
                            borderColor: '#fff',
                            opacity: 0.9,
                            dropShadow: {
                                enabled: false,
                                top: 1,
                                left: 1,
                                blur: 1,
                                color: '#000',
                                opacity: 0.45
                            }
                        },
                        dropShadow: {
                            enabled: false,
                            top: 1,
                            left: 1,
                            blur: 1,
                            color: '#000',
                            opacity: 0.45
                        }
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        categories: data[0],
                        position: 'bottom',
                        tickPlacement: 'on',
                        labels: {
                            rotate: -45,
                            trim: true,
                            rotateAlways: true,
                            minHeight: 150,
                            style: {
                                fontSize: '10px',
                            },
                        }
                    },
                    yaxis: {
                        title: {
                            text: 'reservas'
                        },
                        labels: {
                            formatter: (val) => {
                                if (type === '2') {
                                    return Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(val);
                                }
                                return val;
                            }
                        }
                    },
                    fill: {
                        opacity: 1,
                    },
                };
                this.plotChart(chartOptionsReserve, 'chartReserveBroker');
            }).catch((err) => {
                this.errorMsg(err);
                this.loadingReserveBroker = true
            });
        },

        getDataChart(type) {
            return Dashboard.exportResumBrokerByAllotment(sessionStorage.getItem('allotmentId'), type, this.dateStart, this.dateEnd);
        },

        plotChart(chartOptionsReserve, id) {
            let elChartReserve = document.getElementById(id);
            if (id === 'chartReserveBroker' && elChartReserve) {
                this.chartGraphicBroker?.destroy();
                this.chartGraphicBroker = new ApexCharts(elChartReserve, chartOptionsReserve);
                this.chartGraphicBroker.render();
                this.loadingReserveBroker = true;
                this.showGraficBroker = true;
            } else if (id === 'chartReserve' && elChartReserve) {
                this.chartGraphic?.destroy();
                this.chartGraphic = new ApexCharts(elChartReserve, chartOptionsReserve);
                this.chartGraphic.render();
                this.loadingReserve = true;
            } else if (id === 'chartReserveImobi' && elChartReserve) {
                this.chartGraphicImobi?.destroy();
                this.chartGraphicImobi = new ApexCharts(elChartReserve, chartOptionsReserve);
                this.chartGraphicImobi.render();
                this.loadingReserveImobi = true;
                this.showGraficImobi = true;
            }
        },
    },
}

</script>
<style scoped>
.flap-animation {
    animation: flap 1s forwards; /* Ajuste o tempo da animação conforme necessário */
}

@keyframes flap {
    0% {
        opacity: 0.8;
    }
    50% {
        opacity: 0.5;

    }
    100% {
        opacity: 1;
    }
}

.home-section-title {
    align-items: center;
    border-left: 4px solid #0e5e4e;
    color: #173b34;
    display: flex;
    font-size: 0.98rem;
    font-weight: 800;
    gap: 0.5rem;
    margin: 0;
    padding-left: 0.65rem;
}

.home-section-title i {
    color: #0e5e4e;
    font-size: 1rem;
}

.home-section-title--block {
    margin: 1.15rem 0 0.75rem;
}

.home-chart-card {
    border-radius: 14px;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
    margin-bottom: 0.75rem;
    padding: 1rem 1rem 0.5rem;
}

.home-chart-card__header {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: space-between;
    margin-bottom: 0.85rem;
}

.home-chart-card__filters {
    align-items: flex-end;
    display: flex;
    flex-wrap: wrap;
    gap: 0.6rem;
}

.home-chart-card__field {
    width: 170px;
}

.home-chart-card__field label {
    color: #173b34;
    display: block;
    font-size: 0.75rem;
    font-weight: 800;
    margin-bottom: 0.3rem;
}

.home-charts-grid {
    display: grid;
    gap: 0.75rem;
    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
    margin-bottom: 0.75rem;
}

.home-chart-loading {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 1.5rem 0;
}

.home-segmented {
    background: #e8f1ee;
    border-radius: 12px;
    display: inline-flex;
    gap: 4px;
    padding: 4px;
}

.home-segmented button {
    align-items: center;
    background: transparent;
    border: 0;
    border-radius: 9px;
    color: #51616d;
    display: inline-flex;
    font-size: 0.8rem;
    font-weight: 800;
    gap: 0.35rem;
    min-height: 36px;
    padding: 0.45rem 0.95rem;
    transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
    white-space: nowrap;
}

.home-segmented button:hover {
    color: #0e5e4e;
}

.home-segmented button.active {
    background: #0e5e4e;
    box-shadow: 0 8px 18px rgba(14, 94, 78, 0.20);
    color: #ffffff;
}

html.dark-theme .home-section-title {
    border-left-color: #14b8a6 !important;
    color: var(--dark-text) !important;
}

html.dark-theme .home-section-title i {
    color: #5eead4 !important;
}

html.dark-theme .home-chart-card {
    border-color: var(--dark-border) !important;
}

html.dark-theme .home-chart-card__field label {
    color: var(--dark-text) !important;
}

html.dark-theme .home-segmented {
    background: rgba(15, 23, 42, 0.42) !important;
}

html.dark-theme .home-segmented button {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .home-segmented button:hover {
    color: #5eead4 !important;
}

html.dark-theme .home-segmented button.active {
    background: #14b8a6 !important;
    color: #ffffff !important;
}

@media (max-width: 575px) {
    .home-chart-card__header {
        align-items: stretch;
        flex-direction: column;
    }

    .home-chart-card__field {
        flex: 1 1 140px;
        width: auto;
    }
}
</style>
